import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Toaster } from "react-hot-toast";
// import { updateOrganizationInfo } from "../src/redux/slices/organizationDetails";
import "./App.css";
import AuthenticatedRouter from "./Routers/AuthenticatedRouter";
import {
  getNotifications,
  // getOrganizationSettingsInfo,
  updateDeviceToken,
} from "./api/services/hroneApi";
import "./firebase";
import {
  setDeviceToken,
  setNotifications,
} from "./redux/slices/notificationSlice";
import {
  clearPermissions,
  fetchPermissions,
  usePermissions,
} from "./redux/slices/permissionsSlice";
import LoadingView from "./Components/LoadingView";

function App() {
  const dispatch = useDispatch();
  const userLoggedIn = useSelector((state) => state.notifications.userLogged);

  useEffect(() => {
    if (!userLoggedIn) {
      dispatch(clearPermissions());
      return;
    }
    dispatch(fetchPermissions());
  }, [userLoggedIn, dispatch]);

  return <AppContent />;
}

function AppContent() {
  const messaging = getMessaging();
  const userLoggedIn = useSelector((state) => state.notifications.userLogged);
  const dispatch = useDispatch();
  const { loading, refreshPermissions } = usePermissions();

  useEffect(() => {
    if (userLoggedIn) {
      getNotificationsList();
    } // eslint-disable-next-line
  }, [userLoggedIn]);

  useEffect(() => {
    async function requestPermissionAndToken() {
      try {
        const permission = await Notification.requestPermission();

        if (permission === "granted") {
          try {
            const currentToken = await getToken(messaging, {
              vapidKey: process.env.REACT_APP_VAPID_KEY,
            });
            if (currentToken) {
              localStorage.setItem('devToken', JSON.stringify(currentToken))
              dispatch(setDeviceToken(currentToken));
              if (userLoggedIn) {
                updateDeviceToken(currentToken);
                localStorage.setItem('devToken', JSON.stringify(currentToken))
              }
            }
          } catch (error) { }
        }
      } catch (error) { }
    }

    requestPermissionAndToken();
    return () => {
      localStorage.removeItem('devToken')
    } // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // Handle incoming FCM messages
    const messaging = getMessaging();

    onMessage(messaging, async (payload) => {
      // Silent RBAC control event: the backend intentionally sends this as a
      // data-only message (no `notification` field) whenever the logged-in
      // user's permissions change. It must never surface as a notification —
      // just reload the permission list.
      if (payload.data?.type === "permissions_updated") {
        await refreshPermissions();
        return;
      }

      if (!payload?.notification) {
        return;
      }

      const newNotificationObejct = {
        title: payload.notification.title,
        message: payload.notification.body,
        isRead: false,
        profilePicUrl: payload.notification.image,
      };
      dispatch(setNotifications(newNotificationObejct));
    });

    return () => {
    }; // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (userLoggedIn) {
    } // eslint-disable-next-line
  }, [userLoggedIn]);

  const getNotificationsList = async () => {
    try {
      const response = await getNotifications();
      if (response.ok) {
        const data = await response.json();

        const updatedData = data.map((eachNotification) => ({
          title: eachNotification.title,
          message: eachNotification.message,
          createdAt: eachNotification.created_at,
          isRead: eachNotification.is_read,
          profilePicUrl: eachNotification.profile_picture_url,
        }));
        dispatch(setNotifications(updatedData));
      }
    } catch (err) { }
  };

  // Wait until permissions are resolved before rendering the app (login page
  // renders immediately since unauthenticated loads resolve without a fetch).
  if (loading) {
    return <LoadingView />;
  }

  return (
    <>
      <Toaster containerStyle={{ zIndex: 10000 }} />
      <AuthenticatedRouter />
    </>
  );
}

export default App;
